/* eslint-disable jest/valid-describe */
/* eslint-disable jest/valid-title */
import React from 'react';
import { styled, border, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { DSButton } from '@elliemae/ds-legacy-button-v1';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { DSMobileFooterText } from './Text.js';

const FooterWrap = styled(Grid)`
  background-color: ${(props) => props.theme.colors.neutral['000']};
  border-top: ${(props) => border(props.theme.colors.neutral[100])};
  height: ${(props) => `calc(${__UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs)} * 7)`};
`;

const MobileFooter = ({ children }) => {
  const childArr = React.Children.toArray(children);
  const isButtonType = childArr[0].type === DSMobileFooterText || childArr[0].type === DSButton;
  const setCols = () => {
    if (isButtonType) {
      return childArr.length === 1 ? ['90%'] : ['45%', '45%'];
    }
    return childArr.map(() => `${100 / childArr.length}%`);
  };
  return (
    <FooterWrap>
      <Grid
        cols={setCols()}
        gutter={isButtonType ? 'xs' : undefined}
        justifyContent="center"
        alignItems={isButtonType ? 'center' : undefined}
      >
        {childArr.map((c, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid key={i}>{c}</Grid>
        ))}
      </Grid>
    </FooterWrap>
  );
};

const footerProps = {
  /**
   * Instance of DSButton, DSMobileFooterText or DSMobileFooterAction
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired.description(
    'Instance of DSButton, DSMobileFooterText or DSMobileFooterAction',
  ),
};

MobileFooter.displayName = 'MobileFooter';
const MobileFooterWithSchema = describe(MobileFooter);
MobileFooterWithSchema.propTypes = footerProps;

export default MobileFooter;

export { MobileFooterWithSchema };
